import React from 'react';

import { CaraWorkspaceArtifactType, type ClientArtifactFieldsFragment } from '~/api/graphql';
import { PushEmailToAms, type PushableEmail } from '~/components/ams-email-log/push-email-to-ams';
import { Dash } from '~/components/clients/clients-columns';
import { OutboxAmsCell } from '~/components/mailbox/outbox-ams-cell';
import { useAmsLoggingEnabled } from '~/components/use-ams-logging-enabled';
import type { ArtifactSentEmailState } from './use-client-artifact-sent-emails';

const SentArtifactAmsCell = ({
  email,
  isUnread,
  onRefresh
}: ArtifactSentEmailState & { onRefresh: () => void }) => {
  const amsLog = email?.amsLog ?? null;
  const [pushingEmail, setPushingEmail] = React.useState<PushableEmail | null>(null);

  return (
    <>
      <OutboxAmsCell
        amsLog={amsLog}
        isUnread={isUnread}
        subject={email?.subject}
        onPush={() => {
          if (!email || !amsLog) return;
          setPushingEmail({
            id: email.id,
            subject: email.subject,
            recipients: email.to.map((recipient) => recipient.name || recipient.email).join(', '),
            toAddresses: email.to.map((recipient) => recipient.email),
            sentAt: email.sentAt ?? null,
            amsLog
          });
        }}
      />
      <PushEmailToAms
        email={pushingEmail}
        onAmsLogStale={onRefresh}
        onClose={() => setPushingEmail(null)}
      />
    </>
  );
};

export const ClientArtifactAmsCell = ({
  artifact,
  state,
  onRefresh
}: {
  artifact: Pick<ClientArtifactFieldsFragment, 'id' | 'type'>;
  state: ArtifactSentEmailState | undefined;
  onRefresh: () => void;
}) => {
  const enabled = useAmsLoggingEnabled();
  if (!enabled || artifact.type !== CaraWorkspaceArtifactType.Email) return <Dash />;
  return (
    <SentArtifactAmsCell
      key={artifact.id}
      email={state?.email ?? null}
      isUnread={state?.isUnread ?? false}
      onRefresh={onRefresh}
    />
  );
};
